<div class="bg-white pb-5 mb-5" [class.border]="['INCLUDED','DIGITAL_UPGRADES'].includes(type)">
    <div class="row">
        <div class="col-12">
            <div *ngIf="planCard.subtitle" class="border-bottom">
                <div class="col-md-12 py-5 gb-body3 gb-color-grey-mid-dark pl-6">{{ planCard.subtitle }}</div>
            </div>

            <div class="col-md-12 px-0">
                <div *ngIf="groupedTransitionPlans.length > 0">
                    <webu-plan-transitions *ngFor="let group of groupedTransitionPlans"
                        [transitionPlans]="group"></webu-plan-transitions>
                </div>
                <div *ngFor="let plan of nonTransitionPlans;  let i=index">
                    <webu-plan-display [plan]="plan" [productTag]="planCard.tag" [type]="type"
                        [doDisplayHeaderLine]="(i !== planCard.plans.length-1 && type === 'DIGITAL_UPGRADES') || (type !== 'DIGITAL_UPGRADES')"></webu-plan-display>
                </div>
                <div
                    [ngClass]="{'pl-12 pr-6': groupedTransitionPlans.length > 0, 'px-6': groupedTransitionPlans.length < 1}">
                    <ng-container *ngIf="planCard.nextScheduledPayment">
                        <div *ngIf="canManagePlans" class="gb-body1 heavy">
                            <hr class="my-3" [ngClass]="brand.concat('-hr')">
                            <a class="py-0" 
                                (click)="goToManagePlans()"
                                [attr.aria-label]="managePlansLinkTxt"
                                [trackLink]="managePlansLinkTxt"
                                trackType="o"
                                [prop15]="managePlansLinkTxt"
                                [prop10]="trackingString('link', [trackingPlanName, managePlansLinkTxt])"
                                [evar33]="trackingString('link', [trackingPlanName, managePlansLinkTxt])">
                                <span tabindex="0">{{managePlansLinkTxt}}</span>
                            </a>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="canSeePayments">
                        <ng-container *ngIf="planCard.paymentMethod">
                            <hr class="{{brand}}-hr my-3">
                            <webu-preferred-payment-method
                                [paymentMethod]="planCard.paymentMethod"
                                [parentPlanName]="trackingPlanName">
                            </webu-preferred-payment-method>
                        </ng-container>
                        <ng-container *ngIf="planCard.nextScheduledPayment">
                            <hr class="{{brand}}-hr my-3">
                            <webu-next-payment [nextPayment]="planCard.nextScheduledPayment"></webu-next-payment>
                        </ng-container>
                    </ng-container>
                    
                </div>
                <!-- headline, button, shop more plans link -->
                <div *ngIf="planCard.buttons">
                    <hr [ngClass]="brand.concat('-hr')" class="my-3 mx-6">
                    <ng-container *ngFor="let button of planCard.buttons; index as i">
                        <ng-container [ngSwitch]="button?.type">
                            <!-- buy/manage button -->
                            <ng-container *ngSwitchCase="'PRIMARY'">
                                <div>
                                    <div class="pb-2 gb-align-center gb-body2">
                                        {{button.headerText}}
                                    </div>
                                    <div class="gb-align-center">
                                        <div class="mx-auto" style="width:287px;">
                                            <a  tabindex="0"
                                                (keyup.enter)="handleClick(button.action[0], button.url)"
                                                [attr.aria-label]="button.text" 
                                                [trackLink]="button.text" 
                                                trackType="o"
                                                [prop15]="button.text"
                                                [prop10]="trackingString('button', [trackingPlanName, button.text])"
                                                [evar33]="trackingString('button', [trackingPlanName, button.text])"
                                                *ngIf="button.url" (click)="handleClick(button.action[0], button.url)"
                                                class="gb-primary-button">
                                                @if (isLoading) {
                                                    <ox-loading></ox-loading>
                                                } @else {
                                                    {{button.text}}
                                                }
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <!-- shop More Plans or Cancel Link -->
                            <ng-container *ngSwitchCase="'SECONDARY'">
                                @if (button.action[0] !== 'CANCEL') {
                                    <div class="gb-body2 gb-align-center">
                                        <a class="gb-link justify-content-center" (click)="handleClick(button.action[0],button.url)" 
                                            [trackLink]="button.text" 
                                            trackDelay="true"
                                            trackType="o" 
                                            [prop15]="button.text"
                                            [prop10]="trackingString('link', [trackingPlanName, button.text])"
                                            [evar33]="trackingString('link', [trackingPlanName, button.text])"
                                            [attr.aria-label]="button.text"
                                            tabindex="0"
                                            (keyup.enter)="handleClick(button.action[0], button.url)">
                                            @if (isLoading) {
                                                <ox-loading></ox-loading>
                                            } @else {
                                                <span class="gb-link-label">{{button.text}}</span>
                                            }
                                        </a>
                                    </div>
                                }
                                @else if (isCancelPlanEnabled && button.action[0] === 'CANCEL' && canManagePlans) {
                                    <div class="mx-6">
                                        <div class="pb-2">
                                            <a class="gb-body2 heavy" 
                                                (click)="handleClick(button.action[0], '', button.planCode)" 
                                                [trackLink]="button.text" 
                                                trackDelay="true"
                                                trackType="o" 
                                                [prop15]="button.text"
                                                [prop10]="trackingString('link', [trackingPlanName, button.text])"
                                                [evar33]="trackingString('link', [trackingPlanName, button.text])"
                                                [attr.aria-label]="button.text"
                                                tabindex="0"
                                                (keyup.enter)="handleClick(button.action[0], '', button.planCode)">
                                                <span tabindex="0">{{button.text}}</span>
                                            </a>
                                        </div>
                                        @if (i === planCard.buttons.length-1) {
                                            <span class="mb-0 gb-body3" [innerHTML]="'my_plans_cancel_text' | translate"></span>
                                        }
                                    </div>
                                }
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
